/* eslint-disable prefer-arrow-callback */
/* eslint-disable camelcase */
/* eslint-disable no-loop-func */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-undef */
import $ from 'jquery';
import { Get } from './Get';

window.App = {
  vars: {
    ...Config.vars,
    xhr: '',
    ajaxLoad: {},
  },
  txt: {
    ...Config.txt,
  },
  fn: {
    change_url: (url) => {
      if (history.pushState) {
        history.pushState({ foo: 'bar' }, '', decodeURIComponent(url));
      }
    },
    evalJSFromHtml: (html) => {
      const newElement = document.createElement('div');
      newElement.innerHTML = html;
      const result = newElement.getElementsByTagName('script');
      const scripts = [];
      for (let i = 0; i < result.length; ++i) {
        if (
          result[i].tagName === 'SCRIPT' &&
          (result[i].className === 'ajaxLoad' || result[i].parentNode.className === 'ajaxLoad')
        ) {
          scripts.push(result[i]);
        }
      }
      $('body').append(scripts);
    },
    load: (_url, target, callback, paramets) => {
      if (App.vars.xhr && App.vars.xhr.readystate !== 4) {
        App.vars.xhr.abort();
      }
      $(target).addClass('load-content');
      for (let i = 0; target.length > i; i++) {
        $(target[i][0]).addClass('load-content');
      }
      App.vars.xhr = $.ajax({
        url: _url + paramets,
        timeout: 16000,
        success: (data) => {
          for (let i = 0; target.length > i; i++) {
            $(target[i][0]).removeClass('load-content').html($(data).find(target[i][1]).html());
          }
          App.fn.change_url(_url);
          App.fn.evalJSFromHtml(data);
          if (callback) callback();
        },
        error: () => {
          window.location.href = _url;
        },
      });
    },
    variety: (value, single, plural) => (value === 1 ? single : plural),
    setGrid: () => {
      switch (App.vars.view) {
        case 5:
        case 4:
        case 3:
          $('.domHandler').each(function domHandlerEach() {
            const name = $(this).data('item');
            $(this).after($(name));
            $(this).remove();
          });
          break;
        case 2:
        case 1:
        default:
          if (!$('.domHandler').length) {
            $('.setMobileGrid').each(function setGridEach() {
              const name = $(this).data('item');
              $(name).before(`<del class="domHandler d-none" data-item="${name}">`);
              $(this).append($(name));
            });
          }
          break;
      }
    },
    runAjaxFn: () => {
      App.vars.view = $('#viewType').width();
      App.runArr(App.fnrun.all, 'all', true);
      if (!App.vars.view) return false;
      App.runArr(App.fnrun[App.vars.view], App.vars.view, true);
    },
    getRwdSrc: (obj) => {
      let rwdSrc = [obj.data('src_mobile'), obj.data('src_tablet'), obj.data('src_desktop'), obj.data('src_desktop')];
      let src = rwdSrc[App.vars.view - 1];
      if (!src) {
        rwdSrc = rwdSrc.join(' ').split(' ');
        if (rwdSrc.length) {
          if (App.vars.view === 1) {
            // eslint-disable-next-line prefer-destructuring
            src = rwdSrc[0];
          } else {
            src = rwdSrc.pop();
          }
        }
      }
      return src;
    },
    rwdBanner: (name, view) => {
      for (const i in view) {
        App.run(
          () => {
            $(name)
              .find('img.rwd-src')
              .each(function rwdBannerEach() {
                const $this = $(this);
                $this.attr('src', App.fn.getRwdSrc($this));
              });
          },
          view[i],
          name,
        );
      }
    },
    news_data: (data) => {
      const arr = data && data.data ? data.data.split('-') : '';
      if (arr.length < 3) {
        return false;
      }
      const formatted = data.format || '%d-%m-%y';
      if (data.month_names) arr[1] = data.month_names[parseInt(arr[1], 10) - 1];
      return formatted.format(arr[2], arr[1], arr[0]);
    },
    replaceSelects: (elements, name, callbackOnChange) => {
      elements.each(function replaceSelectEach(i) {
        const $select = $(this);
        const number = i;
        const $selectValue = $select.val();
        const $selectName = $select.attr('name');
        let $labelName = '';
        if ($select.data('label')) {
          $labelName = `<b>${$select.data('label')}</b>`;
        }
        const $ul = $(
          `<div class="f-dropdown f-group ${$select.attr('class')}">
            <ul class="f-dropdown-menu" aria-labelledby="${name}${number}"></ul>
          </div>`,
        );
        $select.children().each(function selectChildrenEach(index) {
          const $option = $(this);
          const $li = $('<li>');
          const dataAttrs = [];
          $.each($option.data(), (key, value) => {
            dataAttrs.push(`data-${key}=${value}`);
          });
          let $data;
          if (dataAttrs.length) {
            $data = dataAttrs.join(' ');
          } else $data = '';
          $(`<a data-index="${index}" ${$data}>`)
            .attr('href', `#${$option.attr('value')}`)
            .attr('data-value', $option.attr('value'))
            .text($option.text())
            .addClass($selectValue === $option.attr('value') ? 'selected' : '')
            .appendTo($li);
          $li.appendTo($ul.find('ul'));
          if ($option.attr('class')) {
            $li.addClass($option.attr('class'));
          }
          if ($option.attr('data-price')) {
            $li.attr('data-price', $option.attr('data-price'));
          }
        });
        $ul
          .prepend(
            `<button
              id="${name}${number}"
              class="f-control f-dropdown-toggle"
              data-indexcurrent="0"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true">
              ${$labelName}
              <span>${$select.find('option:selected').text()}</span>
            </button>`,
          )
          .prepend(
            `<input class="select_hidden searching_ajax" type="hidden" name="${$selectName}" value="${$selectValue}" />`,
          );
        if (callbackOnChange) {
          $ul.find('li').on('click.option', function replaceSelectUlClick() {
            callbackOnChange($(this));
          });
        }
        $select.replaceWith($ul);
      });
    },
    addFocused: function addFocusedClassOnInput(event, selector) {
      const self = selector ? $(selector) : $(this);
      if (self.next().hasClass('control-label') || self.next().hasClass('f-label')) {
        if (self.val() !== '') {
          self.addClass('focused');
        } else {
          self.removeClass('focused');
        }
      }
    },
    dropdownClick: (elem, submit) => {
      const curr = elem.find('a');
      const value = curr.data('value');
      const content = curr.html();
      const ul = elem.parents('.f-dropdown');
      ul.find('input').val(value);
      ul.find('button span').html(content);
      ul.find('.selected').removeClass('selected');
      curr.addClass('selected');
      if (submit) elem.parents('form').submit();
    },
    sesion2link: () => {
      const client = $.cookie('client');
      const name = 'client';
      const regex = new RegExp(`[\\?&]${name}([^&#]*)`);
      if (
        !(client && !$.isEmptyObject(App.vars.sites) && App.vars.session_share && App.vars.session_share === 'true')
      ) {
        return false;
      }
      $('a[href*="http://"],a[href*="https://"],a[href^="//"]').each(function sessionToLinkEach() {
        if ($.inArray(this.hostname, App.vars.sites) !== -1) {
          const link = $(this).get(0);
          const url = link.href;
          const results = regex.exec(url);
          if (results == null) {
            if (url.indexOf('?') !== -1) {
              link.pathname += `&client=${client}`;
            } else {
              link.pathname += `?client=${client}`;
            }
          }
        }
      });
    },
    mobileMenuGen: (reverse = false) => {
      if (reverse) {
        $('.--mobile-label').remove();
      } else if ($('.--mobile-label').length <= 2) {
        const menuList = $('aside .nav-link + .navbar__wrapper');
        $.each(menuList, (index, val) => {
          const navHeader = $(val).prev();
          $(val).prepend(`<div class="--mobile-label">
            <div class="nav-header"></div>
            <button type="button" class="navbar-toggler">
              <div class="hamburger --squeeze">
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <line x1="1" y1="1" x2="13" y2="13" stroke="#192239" stroke-width="2"/>
                  <line x1="13" y1="1" x2="1" y2="13" stroke="#192239" stroke-width="2"/>
                </svg>
              </div>
            </button>
          </div>`);
          $(val).find('.nav-header').prepend(navHeader.clone());
        });
        const menuSubList = $('.nav-link.--has-child');
        menuSubList.each(function menuSubListEach() {
          const subSubMenu = $(this)
            .parents('.navbar__wrapper')
            .find(`.navbar-subsubnav[data-child_id=${$(this).data('child')}]`);
          subSubMenu.prepend(`<li class="--mobile-label">
            <div class="nav-header"></div>
            <button type="button" class="navbar-toggler">
              <div class="hamburger --squeeze">
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <line x1="1" y1="1" x2="13" y2="13" stroke="#192239" stroke-width="2"/>
                  <line x1="13" y1="1" x2="1" y2="13" stroke="#192239" stroke-width="2"/>
                </svg>
              </div>
            </button>
          </li>`);
          subSubMenu.find('.nav-header').prepend($(this).clone());
        });
      }
    },
    categoryDivider: (selector) => {
      const description = selector || '.search_categoriesdescription_sub';
      const children = $(description).children();
      let categorySize = App.vars.categorySize !== undefined ? App.vars.categorySize : 512;

      if (children.length > 1 && !$('.search_categoriesdescription_next').length && categorySize !== 0) {
        $(description).after(
          `<div class="search_categoriesdescription_next cm"><a class="show_description">${
            App.vars.show_description ? App.vars.show_description : 'Czytaj więcej'
          }</a></div>`,
        );
        $.each(children, (indexInArray, valueOfElement) => {
          const amountWithElementLength = (categorySize - valueOfElement.innerText.length) * -1;
          if (categorySize - valueOfElement.innerText.length <= 0 && amountWithElementLength >= categorySize) {
            $(valueOfElement).appendTo('.search_categoriesdescription_next');
          }
          categorySize -= valueOfElement.innerText.length;
        });
      }
      $(description).removeClass('skeleton');
      return false;
    },
    deviceTests: () => {
      const classes = [];
      if ('ontouchstart' in window) classes.push('touch');
      else classes.push('no-touch');

      classes.forEach((newClass) => {
        document.querySelector('body').classList.add(newClass);
      });
    },
  },
  fnrun: {},
  files: [],
  run: (fun, mode, wrapper, ajax) => {
    if ($.isArray(mode)) {
      let i;
      for (i in mode) {
        if (!App.fnrun[mode[i]]) App.fnrun[mode[i]] = [];
        App.fnrun[mode[i]].push({ w: wrapper, fn: fun, a: ajax });
      }
    } else {
      if (!App.fnrun[mode]) App.fnrun[mode] = [];
      App.fnrun[mode].push({ w: wrapper, fn: fun, a: ajax });
    }
  },
  runArr: (arr, mode, ajax) => {
    if (arr) {
      let i;
      let z = 0;
      for (i = 0, z = arr.length; i < z; i++) {
        const { w, fn, a } = arr[i];
        if (ajax) {
          if (w) {
            if ($(w).length && a) {
              fn();
            }
          } else {
            if (a) {
              fn();
            }
          }
        } else {
          if (w) {
            if ($(w).length) {
              fn();
            }
          } else {
            fn();
          }
        }
      }
    }
  },
  runApp: () => {
    App.fn.deviceTests();
    App.vars.view = $('#viewType').width();
    let tmpView = App.vars.view;
    App.runArr(App.fnrun.all, 'all');
    if (!App.vars.view) return false;
    App.runArr(App.fnrun[App.vars.view], App.vars.view);
    App.fn.setGrid();
    $(window).off('resize.view');
    $(window).on('resize.view', () => {
      App.vars.view = $('#viewType').width();
      if (App.vars.view !== tmpView) {
        tmpView = App.vars.view;
        App.runArr(App.fnrun[App.vars.view], App.vars.view);
        App.fn.setGrid();
      }
    });
    Get.init();
    // iaiGet.init();
  },
};

export default App;

export const getSectionLabelByKey = (label) => {
  const { products, series, categories, producers, cms } = Literals.searchList;
  switch (label) {
    case 'products':
      return products;
    case 'series':
      return series;
    case 'menuNodes':
      return categories;
    case 'producers':
      return producers;
    case 'cms':
      return cms;
    default:
      return '';
  }
};

export const renderProductList = (productArray, mode) =>
  productArray
    .map((product) => {
      const {
        icon_small,
        icon,
        link,
        prices,
        price,
        name,
        count,
        price_unit,
        id,
        size,
        md5_additional,
        attributes,
      } = product;
      return `
    <li class="cartlist__product d-flex align-items-center">
      <a class="icon" href="${link}">
        <img class="b-lazy" src="/gfx/{{$xml->getItem('/shop/language/@id')}}/loader.svg" data-src="${
          icon_small ? icon_small : icon
        }" />
      </a>
      <div class="cartlist__details">
        <div class="prices">
          <strong class="price">${prices ? prices.worth_gros_formatted : price.price_formatted}</strong>
        </div>
        <a class="name" href="${link}">${name}</a>
        ${price_unit ? `<div class="count">${count} ${price_unit}</div>` : ''}
      </div>
      ${
        mode
          ? `<a class="remove" href="/basketchange.php?product=${
              id ? id : attributes.id
            }&change=empty&mode=${mode}&size=${typeof size === 'string' ? size : size.attributes.type}${
              md5_additional ? `&additional=${md5_additional}` : ''
            }">
        <svg xmlns="http://www.w3.org/2000/svg" width="9.707" height="9.707" viewBox="0 0 9.707 9.707">
          <g transform="translate(-342.201 -670.201)">
            <line x2="9" y2="9" transform="translate(342.555 670.555)" fill="none" stroke="#1a1a1a" stroke-width="1"/>
            <line x1="9" y2="9" transform="translate(342.555 670.555)" fill="none" stroke="#1a1a1a" stroke-width="1"/>
          </g>
        </svg>
      </a>`
          : ''
      }
    </li>
  `;
    })
    .join('');

export const renderListSection = (label, list) => `
<div class="searchResult__section">
  <div class="searchResult__label">${getSectionLabelByKey(label)}</div>
  <ul class="searchResult__list">
    ${
      label === 'products'
        ? renderProductList(list)
        : list
            .map(
              (element) => `<li class="searchResult__item --link"><a href="${element.link}">${element.name}</a></li>`,
            )
            .join('')
    }
  </ul>
</div>
`;

export const getSearchByText = async (text) => {
  const res = await $.get(`/search.php?xmlType=typeahead&getProductXML=true&json=true&text=${text}&limit=6`);
  return res;
};

export const renderSearchList = async (value, selector) => {
  $(selector).addClass('--loading');

  const res = await getSearchByText(value);
  const parsedData = JSON.parse(res);

  const html = Object.entries(parsedData)
    .map(([label, list]) => (list.length ? renderListSection(label, list) : ''))
    .join('');

  $(selector).html(
    html
      ? html
      : `<div class="d-flex align-items-center justify-content-center" style="height: 100%">${App.vars.basketLiterals.nothingToShow}</div>`,
  );
  App.vars.bLazy.revalidate();
  $(selector).removeClass('--loading');
};
